import { cosemApi } from '@services/providers/cosem';
import { ServiceCode, ServiceCodeToCreate, ServiceCodeToUpdate } from './service-codes.types';
import { ApiPaginationResponse, ApiResponse } from '@services/providers/cosem.types';

const serviceCodesApi = cosemApi.injectEndpoints({
    endpoints: (build) => ({
        getPaginatedServiceCodes: build.mutation<
            ApiPaginationResponse<ServiceCode>,
            { limit?: number; page?: number; search?: string; orderBy?: string }
        >({
            query: ({ limit = 10, page = 1, search, orderBy }) => {
                return {
                    url: `/member/service-codes/paginated`,
                    method: 'GET',
                    params: { limit, page, search: search ?? '', orderBy: orderBy ?? '' }
                };
            },
            transformResponse: (response: ApiPaginationResponse<ServiceCode>) => response
        }),
        getArchivedPaginatedServiceCodes: build.mutation<
            ApiPaginationResponse<ServiceCode>,
            { limit?: number; page?: number; search?: string; orderBy?: string }
        >({
            query: ({ limit = 10, page = 1, search, orderBy }) => {
                return {
                    url: `/member/service-codes/archived/paginated`,
                    method: 'GET',
                    params: { limit, page, search: search ?? '', orderBy: orderBy ?? '' }
                };
            },
            transformResponse: (response: ApiPaginationResponse<ServiceCode>) => response
        }),
        updateServiceCode: build.mutation<ApiResponse<ServiceCode>, ServiceCodeToUpdate>({
            query: (serviceCode: ServiceCodeToUpdate) => {
                return {
                    url: `/member/service-codes/${serviceCode.id}`,
                    method: 'PUT',
                    body: serviceCode
                };
            },
            transformResponse: (response: ApiResponse<ServiceCode>) => response
        }),
        createServiceCode: build.mutation<ApiResponse<ServiceCode>, ServiceCodeToCreate>({
            query: (serviceCode: ServiceCodeToCreate) => {
                return {
                    url: `/member/service-codes`,
                    method: 'POST',
                    body: serviceCode
                };
            },
            transformResponse: (response: ApiResponse<ServiceCode>) => response
        }),
        deleteServiceCode: build.mutation<ApiResponse<ServiceCode>, { id: string }>({
            query: ({ id }) => {
                return {
                    url: `/member/service-codes/${id}`,
                    method: 'DELETE'
                };
            },
            transformResponse: (response: ApiResponse<ServiceCode>) => response
        }),
        toggleArchiveServiceCode: build.mutation<ApiResponse<ServiceCode>, { id: string|number, archived: boolean }>({
            query: ({ id, archived }) => {
                return { 
                    url: `/member/service-codes/${id}/archive`, 
                    method: 'PUT',
                    body: { archived }
                };
            },
            transformResponse: (response: ApiResponse<ServiceCode>) => response
        }),
    })
});

export const {
    useGetPaginatedServiceCodesMutation,
    useGetArchivedPaginatedServiceCodesMutation,
    useUpdateServiceCodeMutation,
    useCreateServiceCodeMutation,
    useDeleteServiceCodeMutation,
    useToggleArchiveServiceCodeMutation
} = serviceCodesApi;
